$( document ).ready(function(){

    var geocoder = new google.maps.Geocoder();

    $("#set-geolocation").on('click', function(e) 
    {
        e.preventDefault();
        localStorage.removeItem('storedLocVars');
        getLocation();
        
        function getLocation() 
        {
          if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(setPosition);
          } 
          else { 
            alert("Geolocation is not supported by this browser.");
          }
        }
        function setCookie(name,value,days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "")  + expires + "; path=/";
        }

        function setPosition(position) 
        {
          var LatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
 
          geocoder.geocode({'location': LatLng}, function(results, status) 
          {
            if (status === 'OK') {
              if (results[0]) 
              {
                var city = "";
                var area = "";
                var postcode = "";
                var country = "";

                for (var ac = 0; ac < results[0].address_components.length; ac++) 
                {
                    var component = results[0].address_components[ac];

                    switch(component.types[0]) {
                      case 'locality':  
                        city = component.short_name;
                        break;
                      case 'postal_town':  
                        city = component.short_name;
                        break;
                      case 'administrative_area_level_1':
                        area = component.short_name;
                        break;
                      case 'postal_code':
                        postcode = component.short_name;
                        break;
                      case 'country':
                        country = component.short_name;
                        break;

                    }
                };

                setCookie('userLocation_Lat', position.coords.latitude, 1 );
                setCookie('userLocation_Lng', position.coords.longitude, 1 );
                setCookie('userLocation_City', city, 1 );
                setCookie('userLocation_Area', area, 1 );
                setCookie('userLocation_Postcode', postcode, 1 );

                var url = window.location.href;    
                /*if (url.indexOf('?') > -1)
                {
                   url += '&geocode=1'
                }
                else
                {
                   url += '?geocode=1'
                }*/
                window.location.href = url;

                //location.reload(); // kick it into the cookie jar

              } 
              else 
              {
                //console.log('Gecoder - No results found');
              }
            } 
            else 
            {
              //console.log('Geocoder -  failed due to: ' + status);
            }
          });

        }

    });


});